import Logo from "@/assets/home/logo.svg?react";
import "./index.css";
import SearchBar from "@/components/SearchBar.tsx";
import React, { useEffect, useState, useRef } from "react";
import AuthService from "@/services/auth.ts";
import eventBus from "@/utils/eventBus.ts";
import type { ConversationParams, CreateQuestionRequest } from "@/types";
import { aiApi } from "@/api/aiApi.ts";
import { useNavigate, useParams } from "react-router-dom";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar.tsx";
import { useGlobalStore } from "@/store/store.ts";
import setImg from "@/assets/home/set.png";
import outImg from "@/assets/home/out.png";
import add from "@/assets/search/add.png";
import Header from "@/components/header.tsx";
import { useTranslation } from "@/locales";
import StepLoginDialog from "@/components/StepLoginDialog";
import { useIsMobile } from "@/hooks/use-mobile";
import { Settings, Plus, ChevronRight, LogOut, MoreVertical } from "lucide-react";
import Loading from "@/icons/three-dots.svg?react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useChatHistory } from "@/hooks/useChatHistory";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { ExclamationCircleIcon } from "@heroicons/react/16/solid";
import type { Record as ChatRecordItem } from "@/types";
import Edit from "@/assets/search/edit.svg?react";
import Delete from "@/assets/search/delete.svg?react";
import EditTitleDialog from "./DetailPage/component/EditTitleDialog";

export default function HomePage() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const userInfo = useGlobalStore((state) => state.user);
  const token = AuthService.getAccessToken();
  const [loginOpen, setLoginOpen] = useState(false);
  const { chatRecord, isLoading, hasMore, loadMore, deleteTopic, updateTopicName } = useChatHistory();
  const { paramsId } = useParams<{ paramsId: string }>();
  const [delDialogOpen, setDelDialogOpen] = useState(false);
  const [delTarget, setDelTarget] = useState<ChatRecordItem | null>(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<ChatRecordItem | null>(null);

  const handleTitleEdit = (title: string, topicNo: string) => {
    updateTopicName(topicNo, title);
  };

  const onEdit = (item: ChatRecordItem) => {
    setEditingItem(item);
    setEditDialogOpen(true);
  };

  const onDel = (item: ChatRecordItem) => {
    setDelTarget(item);
    setDelDialogOpen(true);
  };

  const confirmDelete = async () => {
    if (!delTarget) return;
    const success = await deleteTopic(delTarget.topicNo);
    if (success) {
      if (delTarget.topicNo === paramsId) {
        navigate("/");
        eventBus.emit("load");
      }
    }
    setDelDialogOpen(false);
    setDelTarget(null);
  };
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = "BeeFintech AI";
  }, []);

  // 移动端滚动加载更多
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollContainerRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 5 && hasMore && !isLoading) {
        loadMore();
      }
    }
  };

  const handleLoginSuccess = (data: any) => {
    console.log("登录成功，数据：", data);
  };

  const handleLogout = async () => {
    //退出登录
    AuthService.clearTokens();
    navigate("/", { replace: true });
    window.location.reload();
    return false;
  };

  const createNewChat = () => {
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }
    localStorage.removeItem("question");
    localStorage.removeItem("queryParams");
    navigate("/mobile/newChat", { replace: true });
    eventBus.emit("load");
  };

  const handleSend = async (query: string, modelCode?: string): Promise<void> => {
    if (!query.trim()) return;
    if (!token) {
      setLoginOpen(true);
      return;
    }
    if (!userInfo) return;

    const params: ConversationParams = { question: query, model: modelCode };
    const res = (await aiApi.conversation.create(params)) as CreateQuestionRequest | null;
    localStorage.setItem("question", query);
    localStorage.setItem(
      "queryParams",
      JSON.stringify({
        topicNo: res?.topicNo,
        conversationNo: res?.conversationNo,
        question: query,
      })
    );
    if (res?.topicNo) {
      navigate(`/${res.topicNo}`);
    }
  };

  // if (isMobile) {
  //   // --- 移动端界面 ---
  //   return (
  //     <div className="flex-1 h-full bg-[var(--background-page_background_web)] flex flex-col">
  //       <header className="flex items-center justify-between py-3 px-4 border-b bg-white dark:bg-zinc-800 h-16">
  //         <div className="flex items-center gap-1">
  //           <Logo className="w-8 h-8" />
  //           <div className="leading-tight">
  //             <span className="font-extrabold ml-2 text-[14px] leading-[16px]">BeeFintech AI</span>
  //             <br />
  //             {userInfo?.teamName && <span className=" ml-2 text-[10px] leading-[10px] text-[#6A6A60]">{userInfo.teamName}</span>}
  //           </div>
  //         </div>
  //         <div className="flex items-center gap-3">
  //           {token ? (
  //             <DropdownMenu>
  //               <DropdownMenuTrigger asChild>
  //                 <button className="flex items-center gap-2 outline-none focus:outline-none focus-visible:outline-none" type="button">
  //                   {userInfo ? (
  //                     <Avatar>
  //                       <AvatarFallback style={{ backgroundColor: "#0169cc", color: "#fff" }}>
  //                         <span> {userInfo.nickname.slice(0, 1)}</span>
  //                       </AvatarFallback>
  //                     </Avatar>
  //                   ) : (
  //                     <Avatar></Avatar>
  //                   )}
  //                   <div className="text-sm font-medium px-1">{userInfo ? userInfo.nickname : ""}</div>
  //                 </button>
  //               </DropdownMenuTrigger>
  //               <DropdownMenuContent align="end" className="min-w-[7rem]">
  //                 <DropdownMenuItem onClick={() => navigate('/settings')} className="text-[hsl(var(--destructive))] focus:text-[hsl(var(--destructive))] focus:bg-[hsl(var(--destructive))]/10">
  //                   <img src={setImg} alt="" />
  //                   {t("common.settings")}
  //                 </DropdownMenuItem>
  //                 <DropdownMenuItem onClick={handleLogout} className="text-[hsl(var(--destructive))] focus:text-[hsl(var(--destructive))] focus:bg-[hsl(var(--destructive))]/10">
  //                   <img src={outImg} alt="" />
  //                   {t("auth.logout")}
  //                 </DropdownMenuItem>
  //               </DropdownMenuContent>
  //             </DropdownMenu>
  //           ) : null}
  //         </div>
  //       </header>

  //       <main ref={scrollContainerRef} className="flex-1 overflow-auto p-4 pb-20" onScroll={handleScroll}>
  //         {chatRecord.content.length === 0 && !isLoading ? (
  //           <div className="h-full flex items-center justify-center text-muted-foreground">
  //             {t("chat.noHistory")}
  //           </div>
  //         ) : (
  //           <ul className="flex flex-col gap-3">
  //             {chatRecord.content.map((item) => (
  //               <li key={item.topicNo}>
  //                 <div className="bg-white dark:bg-card p-3 rounded-lg shadow-sm flex items-center justify-between min-h-[56px]">
  //                   <div onClick={() => navigate(`/${item.topicNo}`)} className="flex flex-col overflow-hidden flex-1 cursor-pointer">
  //                     <div className="font-medium text-sm truncate">{item.topicName}</div>
  //                     <div className=" text-xs text-gray-400 truncate pt-1">{item.createTime}</div>
  //                   </div>
  //                   <div className="ml-3">
  //                     <DropdownMenu>
  //                       <DropdownMenuTrigger asChild>
  //                         <button onClick={(e) => e.stopPropagation()} className="p-2 -mr-2 outline-none focus:outline-none focus-visible:outline-none">
  //                           <MoreVertical className="text-muted-foreground" size={18} />
  //                         </button>
  //                       </DropdownMenuTrigger>
  //                       <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
  //                         <DropdownMenuItem onClick={() => onEdit(item)}>
  //                           <Edit />
  //                           <span>{t("common.editName")}</span>
  //                         </DropdownMenuItem>
  //                         <DropdownMenuItem onClick={() => onDel(item)} className="text-red-500 focus:text-red-500">
  //                           <Delete />
  //                           <span>{t("common.delete")}</span>
  //                         </DropdownMenuItem>
  //                       </DropdownMenuContent>
  //                     </DropdownMenu>
  //                   </div>
  //                 </div>
  //               </li>
  //             ))}
  //           </ul>
  //         )}
  //         {isLoading && (
  //           <div className="flex justify-center items-center py-4">
  //             <Loading />
  //           </div>
  //         )}
  //       </main>

  //       <footer className="border-t p-3 fixed bottom-0 left-0 right-0 bg-white dark:bg-zinc-800 h-16">
  //         <div className="flex justify-between items-center max-w-2xl mx-auto h-full">
  //           <div>
  //             <Button variant="outline" size="icon" onClick={() => navigate('/settings')}>
  //               <img src={setImg} alt="" />
  //             </Button>
  //           </div>
  //           <Button onClick={createNewChat} className="bg-primary text-primary-foreground px-4 py-2 rounded-full flex items-center gap-2">
  //             <img src={add} className="w-[16px] h-[16px] " alt="" />
  //             <div className="text-white">{t("chat.newChat")}</div>
  //           </Button>
  //         </div>
  //       </footer>
  //       <AlertDialog open={delDialogOpen} onOpenChange={setDelDialogOpen}>
  //         <AlertDialogContent>
  //           <AlertDialogHeader>
  //             <AlertDialogTitle className={"flex items-start"}>
  //               <ExclamationCircleIcon className={"w-[22px] mr-[8px] text-red-500"} /> {t("common.confirmDelete")}
  //             </AlertDialogTitle>
  //             <AlertDialogDescription>{t("common.deleteConversationWarning")}</AlertDialogDescription>
  //           </AlertDialogHeader>
  //           <AlertDialogFooter>
  //             <AlertDialogCancel onClick={() => setDelDialogOpen(false)}>{t("common.cancel")}</AlertDialogCancel>
  //             <AlertDialogAction className={"bg-red-500 hover:bg-red-600"} onClick={confirmDelete}>
  //               {t("common.confirmDelete")}
  //             </AlertDialogAction>
  //           </AlertDialogFooter>
  //         </AlertDialogContent>
  //       </AlertDialog>

  //       {editingItem && (
  //         <EditTitleDialog
  //           dialogTitle={editingItem.topicName}
  //           isOpen={editDialogOpen}
  //           topicNo={editingItem.topicNo}
  //           onOpenChange={setEditDialogOpen}
  //           onChangeSuccess={(title) => {
  //             updateTopicName(editingItem.topicNo, title);
  //           }}
  //         />
  //       )}
  //     </div>
  //   );
  // }

  // --- pc端界面 ---
  return (
    <div className="bg-[var(--background-page_background_web)] flex-1 flex flex-col md:rounded-2xl">
      <Header />
      <div className="flex flex-1">
        <div className="flex-1 px-4 flex flex-col home-content">
          <div className="flex-1 min-h-[56px]"></div>
          <div className="mb-10 flex flex-col">
            <div className="m-auto Logo">
              <div className="flex mb-10 max-w-[1017px]">
                <Logo className="w-[32px] h-[32px]" />
                <div className="ml-4">
                  <div>{t("home.greeting")}</div>
                  <div>{t("home.description")}</div>
                </div>
              </div>
            </div>
            <div>
              <SearchBar onSearch={handleSend} />
            </div>
          </div>
          <div className="flex-1"></div>
        </div>
      </div>
      <StepLoginDialog mode="dialog" isOpen={loginOpen} onOpenChange={setLoginOpen} onLoginSuccess={handleLoginSuccess} />
    </div>
  );
}
